module["exports"] = ["Polska"];